import { render } from "./dotai.vue?vue&type=template&id=74ee3a0a&scoped=true"
import script from "./dotai.vue?vue&type=script&lang=js"
export * from "./dotai.vue?vue&type=script&lang=js"

import "./dotai.vue?vue&type=style&index=0&id=74ee3a0a&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ee3a0a"]])

export default __exports__